import { getInjection } from '@/di/inversify.config';
import { Result } from '@/entities';
import { InvitationCodeData } from '@/entities/InvitationCodeData';

export const getInvitationCodeUseCase = async (
	teamLeagueUuid: string,
	organizationUuid: string,
	teamUuid: string
): Promise<Result<InvitationCodeData>> => {
	const leaguesRepository = getInjection('ILeaguesRepository');
	return leaguesRepository.getInvitationCode(teamLeagueUuid, organizationUuid, teamUuid);
};
